import { render, staticRenderFns } from "./INT.vue?vue&type=template&id=1cd66dc1&"
import script from "./INT.vue?vue&type=script&lang=ts&"
export * from "./INT.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports